import React, { useEffect, useRef } from 'react';

const TOAST_AUTO_HIDE_MS = 4000;

/**
 * Notification: info toast (top-right, auto-hides) or modal with OK (requires confirmation).
 * @param {string} message - Text
 * @param {function} onClose - Callback when closed
 * @param {string} [buttonClass] - Button class for modal (sft-btn or btn)
 * @param {boolean} [requireAction] - If true — modal with OK (user must confirm); otherwise toast auto-hides
 */
export default function NotificationPopup({ message, onClose, buttonClass = 'sft-btn', requireAction = false }) {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!message || requireAction) return undefined;
    const t = setTimeout(() => { onCloseRef.current && onCloseRef.current(); }, TOAST_AUTO_HIDE_MS);
    return () => clearTimeout(t);
  }, [message, requireAction]);

  if (!message) return null;
  const isError = /error|failed|failed|❌/i.test(message);
  const color = isError ? '#b00020' : '#0a7a2f';

  // Info toast — top-right, auto-hide after TOAST_AUTO_HIDE_MS
  if (!requireAction) {
    return (
      <div
        className="sft-notification-toast"
        style={{
          position: 'fixed',
          top: 16,
          right: 16,
          zIndex: 9999,
          maxWidth: 420,
          padding: 16,
          borderRadius: 12,
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          background: '#fff',
          color,
          fontSize: 14
        }}
      >
        {message}
      </div>
    );
  }

  // Modal with OK button (proposal accept, etc.)
  return (
    <div
      className="sft-notification-modal-overlay"
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.4)'
      }}
      onClick={onClose}
    >
      <div
        className="sft-notification-modal"
        style={{
          background: '#fff',
          color,
          padding: 20,
          borderRadius: 12,
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          maxWidth: 480,
          margin: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          flexWrap: 'wrap'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <span style={{ flex: 1 }}>{message}</span>
        <button type="button" className={buttonClass} style={{ flexShrink: 0 }} onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
}
